const bundle = {
  close: () => 'Κλείσιμο',
  error: () => 'Σφάλμα',
  warn: () => 'Προειδοποίηση',
  info: () => 'Πληροφορίες',
  confirmation: () => 'Επιβεβαίωση',
  progressIndeterminate: () => 'Σε εξέλιξη',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Μεταξύ ' + p['FROM_SECTION'] + ' και ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Δεν βρέθηκε τμήμα που να συμφωνεί.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Πατήστε το πλήκτρο Εnter για να επιλέξετε τιμή.',
  indexer_touchInstructionText: () =>
    'Πατήστε δύο φορές και κρατήστε πατημένο για να εισέλθετε στη λειτουργία κινήσεων και έπειτα σύρετε προς τα επάνω ή προς τα κάτω για να προσαρμόσετε την τιμή.',
  inputPassword_show: () => 'Εμφ. κωδ. πρόσβασης',
  inputPassword_hide: () => 'Απόκρυψη κωδικού πρόσβασης',
  inputPassword_hidden: () => 'Ο κωδικός πρόσβασης κρύφτηκε',
  formControl_clear: () => 'Εκκαθάριση',
  formControl_loading: () => 'Φόρτωση',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Υπέρβαση μέγιστου μήκους ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Απομένουν ' + p['CHARACTER_COUNT'] + ' χαρακτήρες.',
  select_noMatchesFound: () => 'Δεν βρέθηκαν αποτελέσματα.',
  select_oneMatchFound: () => 'Βρέθηκε ένα αποτέλεσμα',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Βρέθηκαν ' + p['TOTAL_SIZE'] + ' αποτελέσματα',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Βρέθηκαν ' + p['TOTAL_SIZE'] + ' ή περισσότερα αποτελέσματα',
  selectMultiple_showSelectedValues: () => 'Εμφάνιση μόνο των επιλεγμένων τιμών.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Επιλέχθηκαν ' + p['VALUE_COUNT'] + ' τιμές.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Ενεργοποιήθηκε το πλαίσιο επιλογής',
  selector_unselected: () => 'Το πλαίσιο επιλογής δεν είναι ενεργοποιημένο',
  userAssistance_learnMore: () => 'Μάθετε περισσότερα',
  userAssistance_required: () => 'Απαιτείται',
  filePicker_singleFileUploadError: () => 'Κάντε αποστολή ενός αρχείου τη φορά',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Δεν μπορείτε να αποστείλετε αρχεία τύπου ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Δεν μπορείτε να αποστείλετε αρχεία τύπου: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'άγνωστος',
  filePicker_dropzonePrimaryText: () => 'Μεταφορά και απόθεση',
  filePicker_dropzoneSecondaryText: () =>
    'Επιλέξτε ένα αρχείο ή πραγματοποιήστε απόθεση ενός αρχείου εδώ',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    'Επιλέξτε αρχεία ή πραγματοποιήστε απόθεση αρχείων εδώ',
  filePicker_addFiles: () => 'Προσθήκη αρχείων',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Αύξηση',
  inputNumber_decrease: () => 'Μείωση',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Δεν υπάρχουν στοιχεία για εμφάνιση',
  message_navigationFromMessagesRegion: () =>
    'Περιοχή εισαγωγής μηνυμάτων. Πατήστε το F6 για πλοήγηση σε προηγούμενο εστιασμένο στοιχείο.',
  message_navigationToMessagesRegion: () =>
    'Η περιοχή μηνυμάτων έχει νέα μηνύματα. Πατήστε το F6 για πλοήγηση στην πιο πρόσφατη περιοχή μηνυμάτων.',
  messageToast_allMessagesClosed: () => 'Όλες οι αναδυόμενες ειδοποιήσεις έκλεισαν.'
};
export default bundle;
